import { TenantFeatures } from "./tenantFeatures"

export enum EditDataPermission {
	Fields,
	Templates,
	ObjectDefinitions,
	Areas,
	Tags,
	Rules,
	Views,
	CadenceSchedules,
	Info,
	UserUpdates,
	CreateDataSource,
	DataSourceList,
	Formats,
	DataSourceSettings,
	Reports,
	DataSourceSLAs
}

export interface PermissionData {
	id: EditDataPermission | string
	title: string
	hideAsRoute?: boolean,
	path?: string
	component?: () => Promise<typeof import("*.vue")>
	tenantFeature?: TenantFeatures
}

export const EditDataPermissionTitles: PermissionData[] = [
	{
		id: EditDataPermission.Fields,
		title: "Fields",
		path: "fields",
		component: () => import("@/components/Config/Fields/FieldSetup.vue")
	},
	{
		id: EditDataPermission.Templates,
		title: "Templates",
		path: "templates",
		component: () => import("@/components/Config/Template/TemplateSetup.vue")
	},
	{
		id: EditDataPermission.ObjectDefinitions,
		title: "Object Definitions",
		path: "object-definitions",
		component: () => import("@/components/Config/Definitions/DefinitionSetup.vue")
	},
	{
		id: EditDataPermission.Areas,
		title: "Areas",
		path: "areas",
		component: () => import("@/components/Config/Sources/Areas.vue")
	},
	{
		id: EditDataPermission.Tags,
		title: "Tags",
		path: "tags",
		component: () => import("@/components/Config/Tags/TagSetup.vue")
	},
	{
		id: EditDataPermission.Rules,
		title: "Rules",
		path: "rules",
		component: () => import("@/components/Config/Rules/RuleSetup.vue")
	},
	{
		id: EditDataPermission.Views,
		title: "Views",
		path: "views",
		component: () => import("@/components/Config/Views/ViewSetup.vue")
	},
	{
		id: EditDataPermission.Formats,
		title: "Formats",
		path: "formats",
		component: () => import("@/components/Config/Formats/FormatSetup.vue"),
		tenantFeature: TenantFeatures.EmailFormats
	},
	{
		id: EditDataPermission.Reports,
		title: "Reports",
		path: "reports",
		component: () => import("@/components/Config/Reports/ReportSetup.vue"),
		tenantFeature: TenantFeatures.PdfReports
	},
	{
		id: EditDataPermission.CadenceSchedules,
		title: "Cadence Schedules",
		path: "cadence-schedules",
		component: () => import("@/components/Config/Schedules/CadenceSchedulesStopgap.vue")
	},
	{
		id: EditDataPermission.Info,
		title: "Info",
		path: "info",
		component: () => import("@/components/Config/TenantSettings/TenantInfoSetup.vue")
	},
	{
		id: EditDataPermission.UserUpdates,
		title: "User Updates",
		path: "updates",
		component: () => import("@/components/Updates/UpdatesSetup.vue")
	},
	{
		id: EditDataPermission.CreateDataSource,
		title: "Create Data Source",
		hideAsRoute: true
	},
	{
		id: EditDataPermission.DataSourceList,
		title: "Data Source List",
		hideAsRoute: true,
		path: "data-source/:dataSourceId",
		component: () => import("@/components/Config/Sources/Source.vue")
	},
	{
		id: EditDataPermission.DataSourceSettings,
		title: "Data Source Settings",
		hideAsRoute: true,
		path: "data-source-settings",
		component: () => import("@/components/Config/Sources/SourceSettings.vue"),
		tenantFeature: TenantFeatures.DataSourceFolders
	},
	{
		id: EditDataPermission.DataSourceSLAs,
		title: "Data Source SLAs",
		hideAsRoute: true,
		tenantFeature: TenantFeatures.FieldMetricsSLAs
	}
]
